










import {
  Vue, Component, Mixins, Prop, Watch,
} from 'vue-property-decorator';

import MyCommon from '@/mixins/common';

@Component
export default class extends Mixins(MyCommon) {
  @Prop() obj!: any;

  @Prop() reload!: (...args: any[]) => any;

  @Watch('obj')
  watchObj(val: any, oldVal: any) {
    // console.log(val);
    // console.log(oldVal);
  }

  mounted() {
    // console.log(this.obj);
  }

  onClose(e: any, id: number) {
    e.preventDefault();
    // console.log(e);

    this.showTsConfirm({
      title: '确认信息',
      content: '你确定要删除该占场吗？',
      onOk: async () => {
        // this.confirmLoading = true;
        const res = await this.$store.dispatch(
          'stadium/orderedGroundDeleteById',
          {
            id: this.obj.id,
          },
        );
        if (res && res.Message && res.Message === 'success') {
          this.$message.success(res.Message);
          this.reload();
        } else {
          this.$message.error(res.Message);
        }
      },
    });

    // return false;
  }
}
